"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestWrapper = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const TestWrapper_1 = require("@reactionable/core/lib/testing/TestWrapper");
const Router_1 = require("../router/Router");
function TestWrapper(_a) {
    var { router } = _a, props = tslib_1.__rest(_a, ["router"]);
    const routerProps = Router_1.useRouterProviderProps(Object.assign(Object.assign({}, router), { Component: Router_1.MemoryRouterComponent }));
    return (jsx_runtime_1.jsx(TestWrapper_1.TestWrapper, Object.assign({}, props, { router: routerProps }), void 0));
}
exports.TestWrapper = TestWrapper;
//# sourceMappingURL=TestWrapper.js.map